export const PLAN_CARD_TEST_ID = {
  root: 'PLAN_CARD_ROOT',
  offersAndAlerts: 'PLAN_CARD_OFFERS_AND_ALERTS',
  planCTAWrapper: 'PLAN_CARD_CTA_WRAPPER',
  button: 'PLAN_CARD_BUTTON',
  planCallout: 'PLAN_CARD_CALLOUT',
  planCalloutSkeleton: 'PLAN_CARD_CALLOUT_SKELETON',
  planAlert: 'PLAN_CARD_ALERT',
  planAlertSkeleton: 'PLAN_CARD_ALERT_SKELETON',
  // TODO: remove the planDisclaimer when the activityLevel is implemented
  planDisclaimer: 'PLAN_CARD_DISCLAIMER',
  planActivityLevel: 'PLAN_CARD_ACTIVITY_LEVEL',
  planCostBreakDown: 'PLAN_CARD_COST_BREAKDOWN',
  planSpeedBreakDown: 'PLAN_CARD_SPEED_BREAKDOWN',
  planDownloadMetric: 'PLAN_CARD_DOWNLOAD_METRIC',
  planUploadMetric: 'PLAN_CARD_UPLOAD_METRIC',

  planAddons: 'PLAN_CARD_ADDONS',
  planInclusions: 'PLAN_CARD_INCLUSIONS',
  planSuitability: 'PLAN_CARD_SUITABILITY'
};
